import { Injectable } from '@angular/core';

interface IRegEx {
  Id: number;
  Name: string;
  Value: string;
  InvalidMsg: string;
}

@Injectable({
  providedIn: 'root',
})
export class ValidateResponseService {
  constructor() {}

  private _regularExpressions = '';
  public get regularExpressions() {
    let localStorageRegularExpressions =
      localStorage.getItem('regularExpressions');
    return (this._regularExpressions = localStorageRegularExpressions ?? '');
  }

  getRegExFor(
    inputType:
      | 'Height'
      | 'Weight'
      | 'HourMinutes'
      | 'Numeric(0-999)'
      | 'Numeric(0-10)'
      | 'Numeric(0-100)'
      | 'Email'
      | 'Phone'
      | 'CAGE Code'
      | 'DDTC Reason'
      | 'DUNS Numbers'
      | 'NCAGE Code'
      | 'SSN'
      | 'NAICS'
      | 'Percent'
      | 'MDM Phone'
      | 'MDM Phone1',
  ): IRegEx {
    const emptyRegEx = {
      Id: NaN,
      Name: 'NA',
      Value: 'NA',
      InvalidMsg: 'NA',
    };
    const regularExpressionsData: IRegEx[] = JSON.parse(
      this.regularExpressions,
    );
    return (
      regularExpressionsData.find((item) => item.Name === inputType) ??
      emptyRegEx
    );
  }

  regEx = {
    email: new RegExp(this.getRegExFor('Email').Value),
    tel: new RegExp(this.getRegExFor('Phone').Value),
    cageCode: new RegExp(this.getRegExFor('CAGE Code').Value),
    dunsNumber: new RegExp(this.getRegExFor('DUNS Numbers').Value),
    naics: new RegExp(this.getRegExFor('NAICS').Value),
  };

  dataExpressions = {
    '9': 'email',
    '6': 'number',
    '10': 'tel',
    '19': 'number2',
    '13': 'dunsNumber',
    '16': 'naics',
    '999': 'text',
    '14': 'cageCode',
  };

  validateInput(inputEle: HTMLInputElement) {
    const invalidMsg = {
      email: this.getRegExFor('Email').InvalidMsg,
      tel: this.getRegExFor('Phone').InvalidMsg,
      cageCode: this.getRegExFor('CAGE Code').InvalidMsg,
      dunsNumber: this.getRegExFor('DUNS Numbers').InvalidMsg,
      naics: this.getRegExFor('NAICS').InvalidMsg,
      number2: `Value should be in the range of ${inputEle?.min} and ${inputEle?.max}`,
    };

    const dataExpressionValue: string = String(
      inputEle.attributes.getNamedItem('data-expression')?.value ?? '',
    );

    const responses: string[] = inputEle.value?.split(', ');

    const dataExpressionInputType = this.dataExpressions[dataExpressionValue];

    let isInputValid: boolean;
    if (dataExpressionInputType === 'text') {
      isInputValid = Boolean(inputEle.value);
    } else if (dataExpressionInputType === 'number2') {
      isInputValid = Boolean(inputEle.validity.valid);
    } else if(inputEle.getAttribute('type') == 'date'){
      isInputValid = Boolean(inputEle.getAttribute('value'));
    } else {
      const isEveryResponseValid = responses.every((resp) =>
        Boolean(
          resp && this.regEx[dataExpressionInputType]?.test(String(resp)),
        ),
      );
      isInputValid = isEveryResponseValid;
    }
    const messageContent =
      dataExpressionValue && !isInputValid
        ? invalidMsg[dataExpressionInputType]
        : '';

    const messageHTML =
      !isInputValid && messageContent
        ? `<small style="display:block; color: crimson; margin-top: 0.5rem" name="invalidInputErrorMsg">${messageContent}</small>`
        : '';

    return { isInputValid, messageHTML };
  }
}
